import { CascadiaButtonProps } from "@certn/cascadia/components/button/types";

import { _Button } from "./_Button";

interface Props extends CascadiaButtonProps {}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function WarningButton(props: Props) {
  const { testID = "warning-button" } = props;

  return (
    <_Button
      color="text-inverse"
      fill="background-warning-strong"
      focusStyle="focus-action"
      hoverFill="background-warning-strong-hover"
      shadow="shadow-button"
      testID={testID}
      {...props}
    />
  );
}
